module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: ข้อมูลบริษัท","tab.info.label":"สรุปข้อมูล","tab.tickets.label":"Ticket","tab.users.label":"พนักงาน","tab.user.permission_management":"จัดการการเข้าถึงข้อมูล"}}')
  delete Component.options._Ctor
}
